import React from 'react';
import { FiThumbsUp, FiMessageSquare } from 'react-icons/fi';
import { FaLinkedin, FaTwitter, FaInstagram } from 'react-icons/fa';

const platformIcons = {
  LinkedIn: <FaLinkedin className="text-blue-700" />,
  Twitter: <FaTwitter className="text-blue-400" />,
  Instagram: <FaInstagram className="text-pink-500" />};

const SocialPostCard = ({ post }) => (
  <div className="bg-white p-4 rounded-lg shadow-sm border">
    <div className="flex items-center gap-2 mb-3">
      {platformIcons[post.platform]}
      <p className="font-bold text-gray-800">{post.platform}</p>
    </div>
    <p className="text-gray-600 text-sm mb-4">{post.content}</p>
    <div className="flex justify-end items-center gap-4 text-sm text-gray-500">
      <div className="flex items-center gap-1"><FiThumbsUp size={14} /> {post.likes}</div>
      <div className="flex items-center gap-1"><FiMessageSquare size={14} /> {post.comments}</div>
    </div>
  </div>
);

export default SocialPostCard;
